import Vue from "vue";
import Vuetify from "vuetify";

Vue.use(Vuetify);

export default new Vuetify({
	theme: {
		themes: {
			light: {
				tertiary: "#f94f4f",
				accent: "#38424d",
			},
		},
	},
});
